const WalletConstants = {
  StatusType: {
    1: 'UNUSED',
    2: 'USED',
    3: 'CANCELLED',
    4: 'UNUSED - REASSIGNED',
  },
  WalletTypeForExcel: {
    1: 'ACCEPTANCE - SLA BREACH',
    2: 'ASSIGNMENT - SLA BREACH',
    3: 'ARRIVAL - SLA BREACH',
    4: 'INDENT REJECT',
    5: 'REINDENT',
    6: 'RFQ REINDENT',
    7: 'RECONCILED',
  },
};

module.exports = WalletConstants;
